module.exports = __webpack_public_path__ + "img/IMG_2034.99315fa4.jpg";